export default {
  getPlatform() {
    if (typeof Android !== 'undefined') {
      return 'android';

    } else if (typeof IOS !== 'undefined') {
      return 'ios';
      
    } else {
      return 'web';
    }
  },

  ios(callback) {
    const { WebViewJavascriptBridge } = window;

    if (this.getPlatform() === 'ios') {
      if (window.WebViewJavascriptBridge) {
        callback(WebViewJavascriptBridge);
      } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function() {
          callback(WebViewJavascriptBridge)
        }, false);

        if (document.iosV === '3.0') {
          if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
          }

          window.WVJBCallbacks = [callback];
          
          let WVJBIframe = document.createElement('iframe');
          
          WVJBIframe.style.display = 'none';
          WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
          document.documentElement.appendChild(WVJBIframe);
          
          setTimeout(() => {
            document.documentElement.removeChild(WVJBIframe);
          }, 0);
        }
      }
    }
  },

  iosWebkit(callback) {
    if (this.getPlatform() === 'ios') {
      const { webkit } = window;
      callback(webkit);
    }
  },
  
  android(callback) {
    const { Android } = window;

    if (this.getPlatform() === 'android') {
      if (typeof Android !== 'undefined') {
        callback(Android);
      } else {
        alert('Bridge가 설정되지 않았습니다.');
      }
    }
  },

  web(callback) {
    if (this.getPlatform() === 'web') {
      callback();
    }
  },
}
